var _rect, _mask, _path, _path2, _rect2, _path3, _path4, _ellipse, _ellipse2, _path5, _path6, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path7, _path8, _path9, _path0, _path1, _path10, _ellipse8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgIllustrationOtp = function SvgIllustrationOtp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 160 160"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 159.521,
    y: 0.06,
    fill: "#E4EDFF",
    rx: 79.76
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-otp_svg__a)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "illustration-otp_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M56.867 80.46c-3.85 0-5.866-4.575-3.268-7.416l26.118-28.56a4.08 4.08 0 0 1 6.02 0l26.118 28.56c2.598 2.841.583 7.415-3.267 7.415zm61.769 4.427a4.427 4.427 0 0 0-4.427-4.427H51.246a4.427 4.427 0 0 0-4.428 4.427v29.902a4.428 4.428 0 0 0 4.428 4.428h62.963a4.428 4.428 0 0 0 4.427-4.428z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp_svg__b)",
    fillRule: "evenodd",
    d: "M56.867 80.46c-3.85 0-5.866-4.575-3.268-7.416l26.118-28.56a4.08 4.08 0 0 1 6.02 0l26.118 28.56c2.598 2.841.583 7.415-3.267 7.415zm61.769 4.427a4.427 4.427 0 0 0-4.427-4.427H51.246a4.427 4.427 0 0 0-4.428 4.427v29.902a4.428 4.428 0 0 0 4.428 4.428h62.963a4.428 4.428 0 0 0 4.427-4.428z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp_svg__c)",
    d: "m79.717 44.485-.613-.56zm6.02 0 .613-.56zm-6.633-.56L52.987 72.483l1.225 1.12 26.117-28.56zm7.246 0a4.91 4.91 0 0 0-7.246 0l1.225 1.12a3.25 3.25 0 0 1 4.796 0zm26.118 28.559L86.35 43.924l-1.225 1.12 26.117 28.56zM56.867 81.29h51.721v-1.66H56.867zm-5.621 0h62.963v-1.66H51.246zm-3.598 33.499V84.887h-1.66v29.902zm66.561 3.597H51.246v1.661h62.963zm3.597-33.5v29.903h1.66V84.887zm-3.597 35.161a5.258 5.258 0 0 0 5.257-5.258h-1.66a3.597 3.597 0 0 1-3.597 3.597zm0-38.757a3.598 3.598 0 0 1 3.597 3.597h1.66a5.258 5.258 0 0 0-5.257-5.258zm-62.963-1.66a5.258 5.258 0 0 0-5.258 5.257h1.66a3.597 3.597 0 0 1 3.597-3.597zm59.996-6.026c2.111 2.309.474 6.025-2.654 6.025v1.66c4.571 0 6.965-5.431 3.88-8.805zM45.988 114.79a5.258 5.258 0 0 0 5.258 5.258v-1.661a3.597 3.597 0 0 1-3.598-3.597zm6.999-42.305c-3.086 3.374-.692 8.806 3.88 8.806v-1.66c-3.128 0-4.766-3.717-2.655-6.026z",
    mask: "url(#illustration-otp_svg__d)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 53.916,
    height: 60.682,
    x: 55.997,
    y: 48.077,
    fill: "#fff",
    stroke: "url(#illustration-otp_svg__e)",
    strokeWidth: 0.51,
    rx: 3.825
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFD3FF",
    d: "M110.289 65.698 57.794 77.35a9.163 9.163 0 0 1-3.97-17.89l52.494-11.652a9.162 9.162 0 0 1 10.93 6.96 9.162 9.162 0 0 1-6.959 10.93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9CB9FC",
    d: "M58.615 70.973a1.85 1.85 0 0 1-1.14.757c-.38.084-.74.003-1.081-.245a1.555 1.555 0 0 1-.639-.942c-.074-.332.016-.713.27-1.143.253-.43.95-.933 2.093-1.51-1.261-.07-2.102-.238-2.523-.505-.42-.268-.667-.568-.74-.901-.085-.38-.025-.754.18-1.123.204-.37.496-.596.876-.68a1.89 1.89 0 0 1 1.35.186c.424.23.942.488 1.554.775-.143-.416-.287-.789-.435-1.117a4.672 4.672 0 0 1-.308-.885c-.106-.474-.067-.888.117-1.24.183-.352.5-.578.951-.678.475-.105.874-.044 1.199.183.324.226.54.578.645 1.052.068.309.093.646.075 1.01-.02.366.004.754.07 1.162.446-.572.821-1.042 1.126-1.408.305-.367.671-.598 1.098-.692.38-.085.74-.002 1.082.245.341.249.555.563.639.942.074.332-.03.71-.31 1.133-.279.423-.975.933-2.088 1.529 1.255.045 2.1.206 2.535.483.436.277.69.582.764.914.084.38.024.755-.18 1.124-.206.37-.498.595-.877.68-.428.094-.858.035-1.292-.18-.434-.216-.973-.488-1.62-.818.113.399.256.76.427 1.082.171.323.291.64.36.948.105.475.06.89-.135 1.244-.195.355-.53.585-1.005.69-.451.1-.834.03-1.149-.213-.315-.24-.525-.598-.63-1.074a4.794 4.794 0 0 1-.103-.967c-.005-.36-.031-.76-.079-1.197-.432.52-.791.979-1.076 1.378zM73.036 67.772c-.285.399-.665.652-1.14.757-.38.085-.74.003-1.082-.245a1.554 1.554 0 0 1-.638-.942c-.074-.332.016-.713.27-1.143.252-.43.95-.933 2.092-1.51-1.26-.07-2.101-.238-2.522-.506-.42-.267-.667-.567-.741-.9-.084-.38-.025-.754.18-1.124.205-.368.497-.595.877-.68a1.89 1.89 0 0 1 1.35.187c.424.23.942.488 1.554.775a13.05 13.05 0 0 0-.435-1.118 4.67 4.67 0 0 1-.308-.884c-.106-.475-.067-.888.117-1.24.183-.352.5-.578.951-.678.475-.105.874-.044 1.199.183.324.226.54.578.645 1.052.068.309.093.646.075 1.01a5.5 5.5 0 0 0 .07 1.162c.446-.572.821-1.042 1.126-1.408.305-.367.67-.598 1.098-.692.38-.085.74-.002 1.082.245.341.249.554.563.639.942.073.332-.03.71-.31 1.133-.279.423-.975.933-2.088 1.528 1.255.046 2.1.207 2.535.484.436.277.69.582.764.914.084.38.024.755-.18 1.124-.206.37-.498.595-.877.68-.428.094-.858.035-1.292-.18-.434-.216-.974-.488-1.62-.818.113.399.256.76.427 1.082a3.8 3.8 0 0 1 .36.947c.105.476.06.89-.135 1.245-.195.355-.53.585-1.005.69-.451.1-.834.03-1.149-.213-.315-.24-.525-.599-.63-1.074a4.793 4.793 0 0 1-.103-.967c-.005-.36-.031-.76-.079-1.197-.432.52-.791.979-1.076 1.378zM87.457 64.571a1.85 1.85 0 0 1-1.14.758c-.38.084-.74.002-1.082-.246a1.554 1.554 0 0 1-.638-.941c-.074-.332.015-.713.269-1.143.253-.43.95-.934 2.093-1.511-1.26-.069-2.101-.237-2.522-.505-.42-.267-.668-.568-.741-.9-.085-.38-.025-.755.18-1.124.204-.369.496-.596.877-.68a1.89 1.89 0 0 1 1.349.186c.424.23.942.488 1.554.776-.142-.417-.287-.79-.434-1.118a4.658 4.658 0 0 1-.309-.884c-.105-.475-.066-.889.117-1.24.184-.352.5-.579.952-.678.474-.106.874-.045 1.198.182.324.227.54.578.645 1.052.068.31.093.647.075 1.011-.02.365.004.753.07 1.161.446-.572.821-1.041 1.126-1.408.305-.366.671-.597 1.098-.692.38-.084.74-.002 1.082.245.341.249.555.563.639.942.074.333-.03.71-.309 1.133-.28.424-.976.933-2.089 1.529 1.255.045 2.1.206 2.536.483.435.278.689.582.763.914.084.38.024.755-.18 1.124-.206.37-.498.596-.877.68-.427.095-.858.035-1.292-.18-.434-.215-.973-.488-1.62-.818.113.399.256.76.427 1.082.171.324.291.64.36.948.106.475.06.89-.135 1.244-.195.355-.53.585-1.005.69-.45.1-.834.03-1.149-.212-.315-.241-.525-.599-.63-1.074a4.794 4.794 0 0 1-.103-.968c-.005-.36-.031-.759-.079-1.197-.432.52-.791.98-1.076 1.379zM101.877 61.37a1.85 1.85 0 0 1-1.14.758c-.38.084-.74.003-1.082-.245a1.554 1.554 0 0 1-.638-.942c-.074-.332.016-.713.27-1.143.252-.43.95-.933 2.092-1.51-1.26-.07-2.101-.238-2.522-.506-.42-.267-.667-.567-.741-.9-.084-.38-.024-.754.18-1.124.205-.368.497-.595.877-.68a1.89 1.89 0 0 1 1.349.186c.425.23.943.489 1.555.776-.143-.416-.287-.79-.435-1.118a4.62 4.62 0 0 1-.308-.884c-.106-.475-.067-.888.117-1.24.183-.352.5-.578.951-.678.475-.105.874-.045 1.198.183.325.226.54.578.645 1.052.069.309.093.646.075 1.01-.019.366.005.753.071 1.161.445-.571.821-1.04 1.126-1.407.304-.367.67-.598 1.098-.692.379-.085.74-.002 1.082.245.341.248.554.563.638.942.074.332-.029.71-.309 1.133-.279.423-.976.933-2.089 1.528 1.255.046 2.1.207 2.535.484.436.277.69.582.764.914.084.38.024.755-.181 1.123-.205.37-.497.596-.876.68-.428.095-.858.036-1.292-.18-.434-.215-.974-.487-1.62-.817.113.398.256.76.427 1.082.171.323.291.64.36.947.105.476.06.89-.135 1.245-.195.355-.53.584-1.005.69-.451.1-.834.03-1.149-.213-.315-.24-.525-.598-.63-1.074a4.735 4.735 0 0 1-.103-.967c-.005-.36-.032-.76-.079-1.197-.432.52-.791.979-1.076 1.378z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.602,
    cy: 63.282,
    fill: "url(#illustration-otp_svg__f)",
    rx: 2.992,
    ry: 2.996
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.351,
    cy: 25.994,
    fill: "url(#illustration-otp_svg__g)",
    rx: 2.992,
    ry: 2.996
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-otp_svg__h)",
    strokeWidth: 0.749,
    d: "M120.149 43.15a2.62 2.62 0 0 1-2.618 2.622 2.62 2.62 0 0 1-2.617-2.621 2.62 2.62 0 0 1 2.617-2.622 2.62 2.62 0 0 1 2.618 2.622Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-otp_svg__i)",
    strokeWidth: 0.749,
    d: "M28.754 80.51a2.62 2.62 0 0 1-2.618 2.621 2.62 2.62 0 0 1-2.618-2.621 2.62 2.62 0 0 1 2.618-2.622 2.62 2.62 0 0 1 2.618 2.621Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.359,
    cy: 98.486,
    fill: "url(#illustration-otp_svg__j)",
    rx: 1.496,
    ry: 1.498
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.289,
    cy: 28.828,
    fill: "url(#illustration-otp_svg__k)",
    rx: 1.496,
    ry: 1.498
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.602,
    cy: 91.745,
    fill: "url(#illustration-otp_svg__l)",
    rx: 1.496,
    ry: 1.498
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.697,
    cy: 72.249,
    fill: "url(#illustration-otp_svg__m)",
    rx: 1.101,
    ry: 1.102
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.717,
    cy: 41.561,
    fill: "url(#illustration-otp_svg__n)",
    rx: 1.496,
    ry: 1.498
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-otp_svg__o)",
    strokeWidth: 0.749,
    d: "M121.519 61.784a1.123 1.123 0 1 1-2.246.002 1.123 1.123 0 0 1 2.246-.002Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp_svg__p)",
    fillRule: "evenodd",
    d: "M131.204 52.378a.326.326 0 0 0-.651-.002l-.002.847-.845-.002a.326.326 0 1 0-.002.651l.845.003-.003.847a.325.325 0 1 0 .65.002l.003-.847.846.002c.18 0 .326-.145.326-.325a.325.325 0 0 0-.324-.326l-.846-.003z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp_svg__q)",
    fillRule: "evenodd",
    d: "M130.128 69.813a.325.325 0 1 0-.65-.002l-.003.847-.845-.003a.326.326 0 0 0-.002.652l.845.002-.002.847a.324.324 0 1 0 .65.002l.003-.847.845.003a.326.326 0 0 0 .002-.651l-.845-.003z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp_svg__r)",
    fillRule: "evenodd",
    d: "M47.454 39.27a.374.374 0 1 0-.748.012l.028 2.054-1.862.028a.375.375 0 0 0 .01.749l1.862-.028.024 1.688a.374.374 0 1 0 .748-.012l-.023-1.687 1.88-.029a.375.375 0 0 0-.01-.748l-1.88.028z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp_svg__s)",
    fillRule: "evenodd",
    d: "M26.094 59.206a.374.374 0 1 0-.749.011l.028 2.055-1.862.028a.375.375 0 0 0 .01.748l1.863-.028.023 1.688a.374.374 0 1 0 .748-.011l-.023-1.688 1.88-.028a.375.375 0 0 0-.01-.748l-1.88.028z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp_svg__t)",
    fillRule: "evenodd",
    d: "M127.502 85.709a.374.374 0 1 0-.749.011l.028 2.055-1.862.028a.374.374 0 0 0 .01.748l1.863-.028.023 1.688a.374.374 0 1 0 .748-.011l-.023-1.688 1.88-.028a.374.374 0 0 0-.01-.749l-1.88.028z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-otp_svg__u)",
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.156,
    cy: 129.709,
    fill: "#E9E7F6",
    rx: 44.496,
    ry: 4.326
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.9,
    clipPath: "url(#illustration-otp_svg__v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp_svg__w)",
    d: "m46.818 120.402 72.223-38.74v38.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp_svg__x)",
    d: "m119.041 120.402-72.223-38.74v38.74z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__b",
    x1: 82.727,
    x2: 82.727,
    y1: 43.158,
    y2: 119.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#9FBCFF",
    stopOpacity: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__c",
    x1: 82.727,
    x2: 82.727,
    y1: 43.158,
    y2: 119.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#9FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__e",
    x1: 83.033,
    x2: 83.033,
    y1: 7.209,
    y2: 109.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#AEEA73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__f",
    x1: 39.521,
    x2: 17.918,
    y1: 67.969,
    y2: 62.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__g",
    x1: 88.27,
    x2: 66.667,
    y1: 30.681,
    y2: 24.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__h",
    x1: 117.45,
    x2: 95.847,
    y1: 47.837,
    y2: 42.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__i",
    x1: 26.055,
    x2: 4.452,
    y1: 85.196,
    y2: 79.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__j",
    x1: 135.318,
    x2: 124.517,
    y1: 100.829,
    y2: 97.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__k",
    x1: 64.249,
    x2: 53.447,
    y1: 31.171,
    y2: 28.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__l",
    x1: 39.561,
    x2: 28.76,
    y1: 94.088,
    y2: 91.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__m",
    x1: 121.667,
    x2: 113.717,
    y1: 73.974,
    y2: 71.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__n",
    x1: 92.677,
    x2: 81.875,
    y1: 43.904,
    y2: 41.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__o",
    x1: 120.356,
    x2: 109.555,
    y1: 64.127,
    y2: 61.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__p",
    x1: 130.835,
    x2: 120.033,
    y1: 55.893,
    y2: 53.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__q",
    x1: 129.759,
    x2: 118.958,
    y1: 73.328,
    y2: 70.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__r",
    x1: 44.807,
    x2: 37.21,
    y1: 43.813,
    y2: 30.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__s",
    x1: 23.446,
    x2: 15.849,
    y1: 63.748,
    y2: 50.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__t",
    x1: 124.854,
    x2: 117.257,
    y1: 90.251,
    y2: 77.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__w",
    x1: 100.778,
    x2: 135.921,
    y1: 84.706,
    y2: 138.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#9FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp_svg__x",
    x1: 82.93,
    x2: 54.013,
    y1: 81.662,
    y2: 142.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#9FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-otp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.857 22.917h114.286v113.806H22.857z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-otp_svg__v"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.818 81.662h71.85v34.313a4.427 4.427 0 0 1-4.427 4.427H51.246a4.427 4.427 0 0 1-4.428-4.427z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-otp_svg__u",
    width: 93.936,
    height: 13.596,
    x: 37.188,
    y: 122.911,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8438_157408",
    stdDeviation: 1.236
  })))));
};
var Memo = /*#__PURE__*/memo(SvgIllustrationOtp);
export default Memo;